export default "__VITE_ASSET__BvHNBckW__"